import { createApi } from "@reduxjs/toolkit/query/react";
import baseQueryWithReauth from "../../utils/baseQueryWithReauth";


export const notificationApi = createApi({
    reducerPath: "notificationApi",
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
    getUserNotifications: builder.query({
      query: ({skip, take}) => ({
        url: `/WebNotifications/GetNotifications`,
        method: 'GET',
        params: {Skip: skip, Take: take}
      })
    }),
    markAllNotificationsAsRead: builder.mutation({
      query: (userId) => ({
        url: `/WebNotifications/MarkAllAsRead`,
        method: 'POST',
        body: { userId },
      }),
    }),

    markNotificationAsRead: builder.mutation({
      query: (id) => ({
        url: `/WebNotifications/MarkAsRead`,
        method: 'POST',
        params: { Id: id },
      }),
    }),
    })
})

export const {  
    useGetUserNotificationsQuery,
    useMarkAllNotificationsAsReadMutation,
    useMarkNotificationAsReadMutation } = notificationApi;